<template>
    <!-- Línea de tiempo (historial de una tarjeta o actividad del equipo).
         items = historial de la API [{id,t,q,ty,de,a,txt,cambios, empresa?, tarjeta?}]. -->
    <p v-if="!items.length" class="cr-tl-empty">{{ vacio || crm.t('hist.empty') }}</p>
    <div v-else class="cr-tl">
        <template v-for="(h, i) in items">
            <p v-if="i === 0 || dia(h.t) !== dia(items[i - 1].t)" :key="'d' + h.id" class="cr-tl-day">{{ crm.diaNombre(h.t) }}</p>
            <div :key="h.id" class="cr-tl-item" :class="{ 'cr-tl-card': conTarjeta }" :tabindex="conTarjeta ? 0 : null" :role="conTarjeta ? 'button' : null"
                 @click="conTarjeta && $emit('abrir', h.tarjeta)" @keydown.enter="conTarjeta && $emit('abrir', h.tarjeta)">
                <span class="cr-tl-ico" :class="ICO[h.ty] ? ICO[h.ty][0] : ''" v-html="ICO[h.ty] ? ICO[h.ty][1] : I.info"></span>
                <div class="cr-tl-t">
                    <template v-if="conTarjeta"><b class="cr-tl-emp">{{ h.empresa }}</b> · </template>
                    <b>{{ crm.nombreDe(h.q) }}</b>
                    <template v-if="h.ty === 'new'"> {{ crm.t('hist.t.new') }} <span v-html="crm.estPill(h.a)"></span><div v-if="h.txt" class="cr-tl-diff"><span>{{ origen(h.txt) }}</span></div></template>
                    <template v-else-if="h.ty === 'mov'"> {{ crm.t('hist.t.mov_a') }} <span v-html="crm.estPill(h.de)"></span> {{ crm.t('hist.t.mov_b') }} <span v-html="crm.estPill(h.a)"></span></template>
                    <template v-else-if="h.ty === 'nota'"> {{ crm.t('hist.t.note') }}<div class="cr-tl-note">{{ h.txt }}</div></template>
                    <template v-else-if="h.ty === 'asig'">
                        <template v-if="h.a"> {{ crm.t('hist.t.asig') }} <b>{{ crm.nombreDe(h.a) }}</b></template>
                        <template v-else> {{ h.de ? crm.t('hist.t.unasig_de', { n: crm.nombreDe(h.de) }) : crm.t('hist.t.unasig') }}</template>
                    </template>
                    <template v-else-if="h.ty === 'pri'"> {{ crm.t('hist.t.pri') }} <span v-html="crm.priPill(h.de)"></span> → <span v-html="crm.priPill(h.a)"></span></template>
                    <template v-else-if="h.ty === 'seg'">
                        <template v-if="h.a"> {{ crm.t('hist.t.seg') }} <b>{{ fechaSeg(h.a) }}</b></template>
                        <template v-else> {{ crm.t('hist.t.seg_off') }}</template>
                    </template>
                    <template v-else> {{ h.ty === 'imp' ? crm.t('hist.t.imp', { f: h.txt || 'Excel' }) : crm.t('hist.t.edit') }}
                        <div class="cr-tl-diff"><span v-for="(x, j) in (h.cambios || [])" :key="j"><b>{{ crm.t('fld.' + x.k) }}:</b> <template v-if="x.de"><s>{{ valor(x, 'de') }}</s> → </template>{{ valor(x, 'a') || crm.t('hist.empty_v') }}</span></div>
                    </template>
                    <time :datetime="new Date(h.t).toISOString()" :title="crm.fecha(h.t)">{{ crm.rel(h.t) }}</time>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { I, diaClave } from './crmUtil';

const ICO = { new: ['is-new', I.plus], mov: ['is-mov', I.move], nota: ['is-note', I.note], asig: ['', I.user], pri: ['', I.flag], seg: ['', I.cal], edit: ['', I.edit], imp: ['', I.file] };

export default {
    name: 'CrmTimeline',
    inject: ['crm'],
    props: { items: { type: Array, required: true }, conTarjeta: { type: Boolean, default: false }, vacio: { type: String, default: '' } },
    data() { return { I, ICO }; },
    methods: {
        dia: diaClave,
        fechaSeg(d) { const [y, m, dd] = d.split('-').map(Number); return this.crm.fecha(new Date(y, m - 1, dd, 12).getTime(), false); },
        valor(x, lado) { return x.k === 'prioridad' ? this.crm.t('pri.' + (x[lado] || 'none')) : x[lado]; },
        // Textos que guarda la API ("Creada a mano", "Importada desde X").
        origen(txt) {
            if (txt === 'Creada a mano') return this.crm.t('hist.t.hand');
            const m = /^Importada desde (.+)$/.exec(txt);
            return m ? this.crm.t('hist.t.from', { f: m[1] }) : txt;
        },
    },
};
</script>
